import g4100TypesQuery from '@/utils/g4100TypesQuery';

export default {
  computed: {
    dates() {
      const now = new Date().toLocaleDateString().split('/');
      const year = now[2];
      const years = [];
      for (let i = 0; i < 4; i += 1) {
        years.push(Number(year) - i);
      }
      // eslint-disable-next-line prefer-destructuring
      this.selectedDate = years[0];
      return years;
    },
  },
  methods: {
    getDataFromG4100(table, fields, filters, order) {
      this.loading = true;
      if ('where' in filters && filters.where.length !== 0) {
        const payload = {
          table,
          fields: fields.join(','),
          where: filters.where,
          offset: filters.offset || 0,
          limit: 100,
          count: true,
        };
        if (order) {
          payload.order = order;
        }
        if (this.quicksearch) {
          payload.quicksearch = this.quicksearch;
        }
        this.$http.post('g4100/list', payload).then((response) => {
          this.data = response.data.data;
          if (response.data.count !== undefined) {
            this.totalCount = response.data.count;
          }
          this.finalizeParams(response.data);
        }).catch((err) => {
          if (this.$isNotProd()) {
            // eslint-disable-next-line no-console
            console.log(err);
          }
          this.loading = false;
        });
      }
    },
    async g4100Post({
      url,
      table,
      fields,
      where,
      order,
      datas,
      content,
      id,
    }) {
      let endpoint;
      let payload;
      if (url === 'list') {
        endpoint = 'g4100/list';
        payload = {
          table,
          fields: Array.isArray(fields) ? fields.join(',') : fields,
          where: where || [],
          offset: 0,
          order: order || { id: 'desc' },
        };
      } else {
        endpoint = 'g4100/save';
        const data = {};
        if (fields && datas) {
          fields.forEach((f, i) => { data[f] = datas[i]; });
        }
        if (content !== undefined) {
          data.content = content;
        }
        payload = { table, data };
        if (id !== undefined) {
          payload.id = id;
        }
      }
      const { data: responseData } = await this.$http.post(endpoint, payload);
      return responseData;
    },
    async getTypes() {
      const result = await this.g4100Post({
        url: 'list',
        table: 'tipos_documento',
        fields: ['id', 'cod', 'nombre'],
        where: [],
        order: { id: 'asc' },
      });
      return result.data;
    },
    async getListEntity({ addDateFilter = true } = {}) {
      this.loading = true;
      if (!this.selectedDateChanged && addDateFilter && this.showDateFilter) {
        this.setDateFilter();
      }
      if (this.keyType) {
        await this.setTypeFilter();
      }
      this.getDataFromG4100(
        this.endpoint,
        this.fields,
        this.filters,
        this.order,
      );
    },
    isTypeInFilters(type) {
      return this.filters.where.find((f) => f.value === String(type.id) && f.field === 'id_tipo_documento');
    },
    async setTypeFilter() {
      const types = await this.getTypes();
      this.addForm.types = this.filterTypes(types, true, this.keyType);
      const typesWithoutKeyType = this.filterTypes(types, false, this.keyType);
      typesWithoutKeyType.forEach((type) => {
        if (!this.isTypeInFilters(type)) {
          this.filters.where.push({
            field: 'id_tipo_documento',
            condition: g4100TypesQuery.TYPE_QUERY_DISTINCT,
            value: String(type.id),
          });
        }
      });
    },
    setDateFilter() {
      const [currentYear, nextYear] = this.getYearsDateFilters();
      const dateFilter = [
        {
          field: this.dateFilter,
          condition: g4100TypesQuery.TYPE_QUERY_GREATER_THAN,
          value: currentYear,
        },
        {
          field: this.dateFilter,
          condition: g4100TypesQuery.TYPE_QUERY_LESS_THAN_STRICT,
          value: nextYear,
        },
      ];
      dateFilter.forEach((dF) => this.filters.where.push(dF));
    },
    getYearsDateFilters() {
      const currentYear = `${this.selectedDate}-01-01`;
      const nextYear = `${this.selectedDate + 1}-01-01`;
      return [currentYear, nextYear];
    },
    changeDateFilter() {
      this.page = 1;
      this.filters.offset = 0;
      this.selectedDateChanged = true;
      const [currentYear, nextYear] = this.getYearsDateFilters();
      this.filters.where[
        this.findIndexCreationDate(g4100TypesQuery.TYPE_QUERY_GREATER_THAN)
      ].value = currentYear;
      this.filters.where[
        this.findIndexCreationDate(g4100TypesQuery.TYPE_QUERY_LESS_THAN_STRICT)
      ].value = nextYear;
      this.getListEntity();
    },
    findIndexCreationDate(condition) {
      return this.filters.where.findIndex(
        (f) => f.field === this.dateFilter && f.condition === condition,
      );
    },
    async addEntity(entity) {
      const uploadResult = await this.$http.post('g4100/document/upload', {
        description: entity.externalRef,
        file_name: entity.file.name,
        content_base64: await this.fileToBase64(entity.file),
      });
      let color = 'red';
      let msg = this.$t('not-added');
      const uploadData = uploadResult && uploadResult.data && uploadResult.data.data;
      if (uploadData && uploadData.id) {
        const idDocument = uploadData.id;
        await this.g4100Post({
          url: 'save',
          table: 'documentos',
          id: idDocument,
          fields: ['observaciones', 'id_tipo_documento', 'id_persona_autor', 'nombre_original'],
          datas: [
            entity.observations,
            entity.selectedType,
            String(this.$store.getters.user.personal_id),
            entity.file.name,
          ],
        });
        const idIssue = await this.createIssue({
          description: `Se ha subido correctamente el documento con id: ${idDocument}`,
        });
        await this.linkDocumentAndIssue(idIssue, idDocument);
        await this.$http.post('send-mail', {
          type: 'uploaded-document',
          doc_id: idDocument,
        });
        color = 'var(--green)';
        msg = this.$t('document-created');
        await this.getListEntity({ addDateFilter: false });
        this.$refs.addForm.dialog = false;
        this.$refs.addForm.loading = false;
      }
      this.$refs.snackbar.open({ color, msg });
    },
    async createIssue({
      description,
    }) {
      const { user } = this.$store.getters;
      const agentId = user.agent_id;
      const date = new Date().toISOString();
      const fields = ['persona', 'descripcion', 'entrada', 'tipo'];
      const datas = [
        user.personal_id,
        description,
        `${date.substr(0, 10)} ${date.substr(11, 8)}`,
        process.env.VUE_APP_TYPE_OF_ISSUE_IN_CREATION ?? 47,
      ];
      if (agentId) {
        fields.unshift('anotador', 'responsable');
        datas.unshift(agentId.id, agentId.id);
      }
      const result = await this.g4100Post({
        url: 'save',
        table: 'incidencias',
        fields,
        datas,
      });
      let idIssue = null;
      if (result && result.data) {
        idIssue = result.data.id;
      } else {
        this.$refs.snackbar.open({
          color: 'red',
          msg: this.$t('not-added-issue'),
        });
      }
      return idIssue;
    },
    linkDocumentAndIssueFeedBack(success) {
      let color = 'red';
      let msg = 'link-document-issue-error';
      if (success) {
        color = 'var(--green)';
        msg = 'link-document-issue';
      }
      this.$refs.snackbar.open({
        color,
        msg: this.$t(msg),
      });
    },
    async linkDocumentAndIssue(idIssue, idDocument) {
      if (!idIssue || !idDocument) {
        this.linkDocumentAndIssueFeedBack(false);
        return;
      }
      const reqLinkIssueWithDocument = this.g4100Post({
        url: 'save',
        table: 'union_incidencias_documentos',
        fields: ['incidencia', 'documentos'],
        datas: [String(idIssue), String(idDocument)],
      });
      const reqLinkDocumentWithIssue = this.g4100Post({
        url: 'save',
        table: 'union_documentos_incidencias',
        fields: ['documento', 'incidencias'],
        datas: [String(idDocument), String(idIssue)],
      });
      const res = await Promise.all([reqLinkIssueWithDocument, reqLinkDocumentWithIssue]);
      if (!(res[0] && res[0].data && res[1] && res[1].data)) {
        this.linkDocumentAndIssueFeedBack(false);
      }
    },
    fileToBase64: (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1].replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ''));
      reader.onerror = (error) => reject(error);
    }),
    filterTypes(paramTypes, check, key) {
      const regex = /\[.*?\]/g;
      return paramTypes.filter(
        ({ nombre }) => {
          if (!nombre.match(regex)) return false;
          return (
            check
              ? key.indexOf(nombre.match(regex)[0]) > -1
              : key.indexOf(nombre.match(regex)[0]) === -1
          );
        },
      );
    },
    printPDFG4100(item, endpoint, fileName) {
      const table = endpoint.split('/')[0].replace('union_documentos_', '') || endpoint.split('/')[0];
      let { id } = item;
      if (endpoint.includes('union_documentos_')) {
        id = item.documento.id;
      }
      const isDocumentDownload = table === 'documentos' || endpoint.includes('union_documentos_');
      const apiEndpoint = isDocumentDownload ? 'g4100/document' : 'g4100/print';
      const payload = isDocumentDownload
        ? { document_id: id, signed: 0 }
        : { table, id };
      this.$http.post(apiEndpoint, payload, { responseType: 'arraybuffer' }).then((response) => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const newBlob = new Blob([response.data], { type: 'application/pdf' });
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${this.generateFileName(fileName, item)}.pdf`;
        link.click();
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      }).catch(() => {
        if (this.$refs.snackbar) {
          this.$refs.snackbar.open({ color: 'red', msg: this.$t('pdf-error') });
        }
      });
    },
    generateFileName(fileName, item) {
      let serie = '';
      if (item.id_serie) {
        serie = `_${item.id_serie.cod}`;
      }
      let cod = '';
      if (item.cod) {
        cod = `_${item.cod}`;
      } else if (item.documento) {
        cod = `_${item.documento.cod}`;
      }
      return `${fileName}${cod}${serie}`;
    },
    logoutG4100() {
      this.$logout();
    },
  },
};
